import $ from 'jquery';
import { updateComments as dynamicCsrfUpdateComments } from '@ui/comments/dynamic-csrf';

const elements = {
    config: '.c-comments-config',
};

class shoutboxRepository {
    filter(filters) {
        let filtered = Object.assign({}, filters);
        const allowed = {
            latest: ['page', 'since'],
            best: ['page'],
            live: ['ids', 'last'],
            comment: ['id'],
        };
        for (let key in filters) {
            if (key !== 'type' && allowed[filters.type].indexOf(key) < 0) {
                delete filtered[key];
            }
        }
        return filtered;
    }

    validate(filtered) {
        if (filtered.type === 'live') {
            if (filtered.ids.length === 0) {
                return false;
            }
            /**
             * @TODO
             * validation on backend
             *
             * filtered.ids = filtered.ids.slice(0, 10);
             */
        }
        return true;
    }

    load(filters) {
        let endpoint = $(elements.config).data('comments-api-shoutbox') + '?';

        const promise = new Promise((resolve, reject) => {
            const filtered = this.filter(filters);

            if (!this.validate(filtered)) {
                return reject();
            }

            let args = [];
            for (let key in filtered) {
                if (filtered.hasOwnProperty(key)) {
                    args.push(key + '=' + filtered[key]);
                }
            }
            endpoint += args.join('&');

            $.get(endpoint)
                .done(response => {
                    const { status, data, redirect } = response;
                    switch (status) {
                        case 'ok':
                            dynamicCsrfUpdateComments(data.csrfToken);
                            resolve(data);
                            break;
                        case 'error':
                            reject(data.error);
                            break;
                        case 'redirect':
                            window.location.href = redirect;
                            break;
                        default:
                            break;
                    }
                })
                .fail(error => {
                    reject(error);
                });
        });

        return promise;
    }
}

export default new shoutboxRepository();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/shoutbox/repository.js